import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
  loading: false,
  allEmp: null,
  empList: null,
  empData: null,
  empCreate: null,
  error: null,
  emailTemplate: null,
  response: null,
  seletors: null,
  empPay: null,
  trackerSwitch: null,
  allFilter: null,
  payEmail: null,
  activity: null,
  leaveBalance: null,
  referral: null,
  imageShow: null,
  paysliplist: null,
  removeJob: null,
  walletList: null

};
// get-all-employee list api------------------------------start--------------->

export const getAllEmployeeList = createAsyncThunk(
  "getAllEmployeeList",
  async (body) => {
    try {
      const response = await instance.get(
        `/crm/employees/list-all-employee?fSearch=${body}`
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  }
);

// export const getSingleEmployee = createAsyncThunk(
//   "getSingleEmployee",
//   async (data) => {
//     try {
//       const response = await instance.get(
//         `/crm/employees/get-employee-data?slug=${data}`
//       );
//       return response.data;
//     } catch (err) {
//       throw err;
//     }
//   }
// );

// get-all-employee list api------------------------------start--------------->

export const GetEmployees = createAsyncThunk("GetEmployees", async (body) => {
  try {
    const response = await instance.get(
      `/crm/employees/list-all?page=${body?.page}&fRole=${body?.role}&fProject=${body?.project}&fCompany=${body?.company}&fSearch=${body?.search}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
});

export const GetAllEmployees = createAsyncThunk("GetAllEmployees", async () => {
  try {
    const response = await instance.get(`/crm/employees/list-all`);
    return response.data;
  } catch (error) {
    throw error;
  }
});

export const GetAllEmployeesForTask = createAsyncThunk(
  "GetAllEmployeesForTask",
  async () => {
    try {
      const response = await instance.get(
        `/crm/employees/list-employee-for-task`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const GetSelectors = createAsyncThunk("GetSelectors", async () => {
  try {
    const response = await instance.get("/crm/employees/before-add-employee");
    return response.data;
  } catch (error) {
    throw error;
  }
});

//employee document upload

export const employeeDocumentUpload = createAsyncThunk(
  "employeeDocumentUpload",
  async ({ slug, formData }, thunkAPI) => {
    try {
      const url = `/crm/employees/upload-document?slug=${slug}`;
      const response = await instance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const GetEmailTemplate = createAsyncThunk(
  "GetEmailTemplate",
  async () => {
    try {
      const response = await instance.get("/crm/employees/get-email-template");
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const GetEmployeeData = createAsyncThunk(
  "GetEmployeeData",
  async (slug) => {
    try {
      const response = await instance.get(
        `/crm/employees/get-employee-data?slug=${slug}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const CreateEmployee = createAsyncThunk(
  "CreateEmployee",
  async (body) => {

    try {
      const formData = new FormData();
      formData.append("e_first_name", body.e_first_name);
      formData.append("e_last_name", body.e_last_name);
      formData.append("e_username", body.e_username);
      formData.append("e_password", body.e_password);
      formData.append("e_aadhar_number", body.e_aadhar_number);
      formData.append("e_bd_account_holder", body.e_bd_account_holder);
      formData.append("e_bd_account_number", body.e_bd_account_number);
      formData.append("e_bd_bank_name", body.e_bd_bank_name);
      formData.append("e_bd_ifsc_code", body.e_bd_ifsc_code);
      formData.append("e_current_address", body.e_current_address);
      formData.append("e_designation", body.e_designation);
      formData.append("e_emergency_contact", body.e_emergency_contact);
      formData.append("e_emergency_name", body.e_emergency_name);
      formData.append("e_employment_status", body.e_employment_status);
      formData.append("e_dob", body.e_dob);
      formData.append("e_gender", body.e_gender);
      formData.append("e_email_address", body.e_email_address);
      formData.append("e_professional_email", body.e_professional_email);
      formData.append("e_experience_status", body.e_experience_status);
      formData.append(
        "e_job_experience",
        JSON.stringify(body.e_job_experience)
      );
      formData.append("e_join_date", body.e_join_date);
      formData.append("e_mobile_number", body.e_mobile_number);
      formData.append("e_pan_number", body.e_pan_number);
      formData.append("e_permanent_address", body.e_permanent_address);
      formData.append("e_pin_code", body.e_pin_code);
      formData.append("e_role", body.e_role);
      formData.append("e_slug", body.e_slug);
      formData.append("e_photo", body.e_photo[0]);
      formData.append("e_skills", JSON.stringify(body.e_skills));
      formData.append("e_project", body.e_project);
      formData.append("e_c_suit", body.e_c_suit);
      formData.append("e_project_show", JSON.stringify(body.e_project_show));
      formData.append("e_company", body.e_company);
      formData.append("e_bio_attendance_code", body.e_bio_attendance_code);
      formData.append("e_team_leader", body.e_team_leader);
      formData.append("e_pf_account_number", body.e_pf_account_number);
      formData.append("e_esic_number", body.e_esic_number);
      formData.append("e_uan", body.e_uan);
      // formData.append("pc_status", body.pc_status);
      // formData.append("pc_cc_contract_type", body.pc_cc_contract_type);
      // formData.append("pc_working_hours", body.pc_working_hours);
      // formData.append("pc_wage_contract_salary", body.pc_wage_contract_salary);
      // formData.append("pc_emp_date_of_joining", body.pc_emp_date_of_joining);
      // formData.append("pc_employee_id", body.pc_employee_id);
      // formData.append("pc_salary_structure_id", body.pc_salary_structure_id);
      // formData.append("pc_end_date", body.pc_end_date);
      formData.append("ctc", body.ctc);
      formData.append("basic_percent", body.basic_percent);
      formData.append("hra_percent", body.hra_percent);
      formData.append("ta_percent", body.ta_percent);
      formData.append("lta_percent", body.lta_percent);
      formData.append("medical_percent", body.medical_percent);
      formData.append("special_percent", body.special_percent);

      if (typeof body?.e_documents == "object") {
        // const newArr = [];
        for (let i = 0; i < body?.e_documents?.length; i++) {
          // newArr.push(body?.e_documents[i])
          formData.append("e_documents[]", body?.e_documents[i]);
        }
      } else {
        formData.append("e_documents", []);
      }

      const res = await instance.post(
        "/crm/employees/register-employee",
        formData
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateEmployee = createAsyncThunk(
  "UpdateEmployee",
  async (body) => {

    const formData = new FormData();
    formData.append("e_first_name", body.e_first_name);
    formData.append("e_last_name", body.e_last_name);
    formData.append("e_tikona_id", body.e_tikona_id);
    formData.append("e_username", body.e_username);
    formData.append("e_aadhar_number", body.e_aadhar_number);
    formData.append("e_bd_account_holder", body.e_bd_account_holder);
    formData.append("e_bd_account_number", body.e_bd_account_number);
    formData.append("e_bd_bank_name", body.e_bd_bank_name);
    formData.append("e_bd_ifsc_code", body.e_bd_ifsc_code);
    formData.append("e_gender", body.e_gender);
    formData.append("e_current_address", body.e_current_address);
    formData.append("e_designation", body.e_designation);
    formData.append("e_emergency_contact", body.e_emergency_contact);
    formData.append("e_emergency_name", body.e_emergency_name);
    formData.append("e_employment_status", body.e_employment_status);
    formData.append("e_dob", body.e_dob);
    formData.append("e_email_address", body.e_email_address);
    formData.append("e_professional_email", body.e_professional_email);
    formData.append("e_experience_status", body.e_experience_status);
    formData.append("e_job_experience", JSON.stringify(body.e_job_experience));
    formData.append("e_join_date", body.e_join_date);
    formData.append("e_mobile_number", body.e_mobile_number);
    formData.append("e_pan_number", body.e_pan_number);
    formData.append("e_permanent_address", body.e_permanent_address);
    formData.append("e_pin_code", body.e_pin_code);
    formData.append("e_role", body.e_role);
    formData.append("e_slug", body.e_slug);
    formData.append("e_skills", JSON.stringify(body.e_skills));
    formData.append("e_project", body.e_project);
    formData.append("e_c_suit", body.e_c_suit);
    formData.append("e_project_show", JSON.stringify(body.e_project_show));
    formData.append("e_company", body.e_company);
    formData.append("e_bio_attendance_code", body.e_bio_attendance_code);
    formData.append("e_team_leader", body.e_team_leader);
    formData.append("e_pf_account_number", body.e_pf_account_number);
    formData.append("e_esic_number", body.e_esic_number);
    formData.append("e_uan", body.e_uan);
    // formData.append("pc_status", body.pc_status);
    // formData.append("pc_cc_contract_type", body.pc_cc_contract_type);
    // formData.append("pc_working_hours", body.pc_working_hours);
    // formData.append("pc_wage_contract_salary", body.pc_wage_contract_salary);
    // formData.append("pc_emp_date_of_joining", body.pc_emp_date_of_joining);
    // formData.append("pc_employee_id", body.pc_employee_id);
    // formData.append("pc_salary_structure_id", body.pc_salary_structure_id);
    // formData.append("pc_end_date", body.pc_end_date);

    formData.append("ctc", body.ctc);
    formData.append("basic_percent", body.basic_percent);
    formData.append("hra_percent", body.hra_percent);
    formData.append("ta_percent", body.ta_percent);
    formData.append("lta_percent", body.lta_percent);
    formData.append("medical_percent", body.medical_percent);
    formData.append("special_percent", body.special_percent);



    if (typeof body.e_photo == "string") {
      formData.append("e_photo", body.e_photo);
    } else {
      formData.append("e_photo", body.e_photo[0]);
    }

    if (typeof body?.e_documents == "object") {
      // const newArr = [];
      for (let i = 0; i < body?.e_documents?.length; i++) {
        // newArr.push(body?.e_documents[i])
        formData.append("e_documents[]", body?.e_documents[i]);
      }
    } else {
      formData.append("e_documents", body?.e_documents);
    }

    try {
      const res = await instance.post(
        `/crm/employees/update-employee?slug=${body?.e_slug}`,
        formData
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateEmployeeProfilePhoto = createAsyncThunk(
  "UpdateEmployeeProfilePhoto",
  async (body) => {

    try {
      // const res = await instance.post(
      //   `/crm/employees/update-employee?slug=${body?.e_slug}`,
      //   body
      // );
      // return res?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const sendMailToEmployee = createAsyncThunk(
  "sendMailToEmployee",
  async (body) => {
    try {
      const response = await instance.post("/remark/email/mail-send", body);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const employeeNotification = createAsyncThunk(
  "employeeNotification",
  async (body) => {
    try {
      const response = await instance.get(
        `/crm/employees/send-notification?e_id=${body.e_id}&message=${body.message}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const getAllEmployeelistForBio = createAsyncThunk(
  "getAllEmployeelistForBio",
  async () => {
    try {
      const response = await instance.get(`/crm/employees/get-employee-list`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const getAllFilterPayslip = createAsyncThunk(
  "getAllFilterPayslip",
  async (body) => {
    try {
      const response = await instance.get(`/crm/payslip/payslip-list?slug=${body.slug}&year=${body.year}&month=${body.month}&status=${body.status}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const employeePayslip = createAsyncThunk(
  "employeePayslip",
  async (body) => {
    try {
      const formData = new FormData();
      formData.append("ps_month", body.ps_month);
      formData.append("ps_year", body.ps_year);
      formData.append("ps_username", body.ps_username);
      formData.append("ps_pdf", body.ps_pdf[0])
      const response = await instance.post("/crm/payslip/upload-payslip", formData);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const sendPayslipEmail = createAsyncThunk(
  "sendPayslipEmail",
  async (body) => {
    try {
      const response = await instance.post(`/crm/payslip/send-payslip`, body);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// toggle tracker switch 
export const UpdateTrackerSwitch = createAsyncThunk(
  "UpdateTrackerSwitch",
  async (data) => {
    try {
      const response = await instance.post(`/crm/employees/update-tracker-status?e_id=${data?.e_id}`, { "e_is_track": data?.e_is_track })
      return response.data
    } catch (error) {
      throw error;
    }
  }
)

// {recent activity}
export const fetchAllActivity = createAsyncThunk(
  "fetchAllActivity",
  async (body) => {
    try {
      const response = await instance.get(`/crm/recent-activity/fetch-recent-activity?e_id=${body?.ra_emp_id}&date=${body?.ra_date}`)
      return response.data;
    } catch (error) {
      throw error;
    }
  }
)

// {leave management}
export const fetchAllLeave = createAsyncThunk(
  "fetchAllLeave",
  async (id) => {
    try {
      const response = await instance.get(`/crm/leave/leave-balance?id=${id}`)
      return response.data;
    } catch (error) {
      throw error;
    }
  }
)
// {create wallet}

export const createWallet = createAsyncThunk(
  "createWallet",
  async (data) => {

    try {

      const res = await instance.post(
        "/crm/wallet/create-wallet",
        data
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateWallet = createAsyncThunk(
  "updateWallet",
  async (data) => {

    try {

      const res = await instance.post(
        "/crm/wallet/update-wallet",
        data
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
);
export const fetchAllWallet = createAsyncThunk(
  "fetchAllWallet",
  async () => {
    try {
      const response = await instance.get("/crm/wallet/fetch-wallet")
      return response.data;
    } catch (error) {
      throw error;
    }
  }
)
export const updatePassword = createAsyncThunk(
  "updatePassword",
  async (data) => {

    try {

      const res = await instance.post(
        "/crm/wallet/update-wallet-password",
        data
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
);
// referral code 
export const getReferralCodeList = createAsyncThunk(
  "getReferralCodeList",
  async (referralCode) => {
    try {
      const response = await instance.get(
        `/crm/employees/check-referred?referralCode=${referralCode}`
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  }
);

export const removeImageUpload = createAsyncThunk(
  "removeImageUpload",
  async (body) => {
    try {
      const response = await instance.delete(`/crm/employees/delete-documents?e_id=${body.id}&document_index_id=${body.index}`);
      return response.data
    } catch (error) {

    }
  }
)

export const removePayslipList = createAsyncThunk(
  "payslip/removePayslip",
  async (id, { rejectWithValue }) => {
    try {
      const response = await instance.delete(`/crm/payslip/remove-payslip?id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const deleteJobExperience = createAsyncThunk(
  "deleteJobExperience",
  async (id) => {
    try {
      const response = await instance.delete(`/crm/employees/delete-experiance?id=${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);
export const EmployeesSlice = createSlice({
  name: "EmployeesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetEmployees.pending, (state) => {
      state.empCreate = null;
      state.loading = true;
      state.response = null;
    });
    builder.addCase(GetEmployees.fulfilled, (state, action) => {
      state.loading = false;
      state.empList = action.payload;
    });
    builder.addCase(GetEmployees.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(GetSelectors.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(GetSelectors.fulfilled, (state, action) => {
      state.loading = false;
      state.seletors = action.payload;
    });
    builder.addCase(GetSelectors.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(GetEmailTemplate.pending, (state) => {
      state.empCreate = null;
      state.loading = true;
    });
    builder.addCase(GetEmailTemplate.fulfilled, (state, action) => {
      state.loading = false;
      state.emailTemplate = action.payload;
    });
    builder.addCase(GetEmailTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(GetEmployeeData.pending, (state) => {
      state.empCreate = null;
      state.loading = true;
      state.empData = null;
    });
    builder.addCase(GetEmployeeData.fulfilled, (state, action) => {
      state.loading = false;
      state.empData = action.payload;
    });
    builder.addCase(GetEmployeeData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(CreateEmployee.pending, (state) => {
      state.loading = true;
      state.empCreate = null;
    });
    builder.addCase(CreateEmployee.fulfilled, (state, action) => {
      state.loading = false;
      state.empCreate = action.payload;
    });
    builder.addCase(CreateEmployee.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(UpdateEmployee.pending, (state, action) => {
      state.loading = true;
      state.empCreate = null;
    });
    builder.addCase(UpdateEmployee.fulfilled, (state, action) => {
      state.loading = false;
      state.empCreate = action.payload;
    });
    builder.addCase(UpdateEmployee.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(sendMailToEmployee.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(sendMailToEmployee.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(sendMailToEmployee.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(employeeNotification.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(employeeNotification.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(employeeNotification.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getAllEmployeelistForBio.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAllEmployeelistForBio.fulfilled, (state, action) => {
      state.loading = false;
      state.empList = action.payload;
    });
    builder.addCase(getAllEmployeelistForBio.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(employeePayslip.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(employeePayslip.fulfilled, (state, action) => {
      state.loading = false;
      state.empPay = action?.payload;
    });
    builder.addCase(employeePayslip.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });


    builder.addCase(sendPayslipEmail.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(sendPayslipEmail.fulfilled, (state, action) => {


      state.loading = false;
      state.payEmail = action?.payload;
    });
    builder.addCase(sendPayslipEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // builder.addCase(getAllEmployeeList.pending, (state, action) => {
    //   state.loading = true;
    // });
    builder.addCase(getAllEmployeeList.fulfilled, (state, action) => {
      state.loading = false;
      state.allEmp = action.payload;
    });
    builder.addCase(getAllEmployeeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //upload-documents


    builder.addCase(UpdateTrackerSwitch.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(UpdateTrackerSwitch.fulfilled, (state, action) => {
      state.loading = false;
      state.trackerSwitch = action?.payload;
    });
    builder.addCase(UpdateTrackerSwitch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getAllFilterPayslip.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAllFilterPayslip.fulfilled, (state, action) => {
      state.loading = false;
      state.allFilter = action?.payload;
    });
    builder.addCase(getAllFilterPayslip.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(fetchAllActivity.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllActivity.fulfilled, (state, action) => {
      state.loading = false;
      state.activity = action?.payload;
    });
    builder.addCase(fetchAllActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(fetchAllLeave.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllLeave.fulfilled, (state, action) => {

      state.loading = false;
      state.leaveBalance = action?.payload;
    });
    builder.addCase(fetchAllLeave.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getReferralCodeList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getReferralCodeList.fulfilled, (state, action) => {

      state.loading = false;
      state.referral = action?.payload;
    });
    builder.addCase(getReferralCodeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(removeImageUpload.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(removeImageUpload.fulfilled, (state, action) => {

      state.loading = false;
      state.imageShow = action?.payload;
    });
    builder.addCase(removeImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(removePayslipList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(removePayslipList.fulfilled, (state, action) => {

      state.loading = false;
      state.paysliplist = action?.payload;
    });
    builder.addCase(removePayslipList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteJobExperience.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(deleteJobExperience.fulfilled, (state, action) => {
      state.loading = false;
      state.removeJob = action?.payload;
    });
    builder.addCase(deleteJobExperience.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(fetchAllWallet.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllWallet.fulfilled, (state, action) => {
      state.loading = false;
      state.walletList = action?.payload;
    });
    builder.addCase(fetchAllWallet.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(updateWallet.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateWallet.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action?.payload;
    });
    builder.addCase(updateWallet.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(createWallet.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createWallet.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action?.payload;
    });
    builder.addCase(createWallet.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(updatePassword.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updatePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action?.payload;
    });
    builder.addCase(updatePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },

});

export default EmployeesSlice.reducer;
